import Axios from 'axios'
import React, {useState} from 'react'
import {useEffect} from 'react'
import {Link, useParams} from 'react-router-dom'
import {useCallback} from 'react'

import styles from './ByType.module.css'

import {API_URL} from '../../ApiUrl.js'
import CardGroup from 'reactstrap/lib/CardGroup'
import Card from 'reactstrap/lib/Card'

function ByType() {
  let {typeId} = useParams()
  const [arts, setArts] = useState([])
  const [error, setError] = useState('')
  const [type, setType] = useState('')

  const getArtsByType = useCallback(async () => {
  try {
    const res = await Axios.get(`${API_URL}/api/sculptures`);
    
    // 1. On filtre d'abord par type
    const artsByType = res.data
      .filter((item) => item.TypeId === typeId)
      .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

    // 2. SECURITÉ : On ne définit le type que si on a des résultats
    if (artsByType.length > 0) {
      setType(artsByType[0].Type?.label || "Type inconnu");
      
      // 3. Filtrage des catégories uniques (plus propre)
      const seen = new Set();
      const filteredArr = artsByType.filter((item) => {
        if (!item.Category) return false; // Sécurité si pas de catégorie
        const duplicate = seen.has(item.Category.id);
        seen.add(item.Category.id);
        return !duplicate;
      });
      
      setArts(filteredArr);
    }
  } catch (err) {
    setError("Impossible de charger les œuvres."); // Texte simple
  }
}, [typeId]);
  
  useEffect(() => {
    getArtsByType()
  }, [getArtsByType])

  const handleScrollToTop = () => {
    window.scrollTo(0, 0);
  };

  return (
    <div className={styles.byTypeStyle}>
      {error && <p className="text-danger text-center">{error}</p>}
      
      <h1 className="title-centered text-center mt-4">{type}</h1>
      
      <div className={styles.containerFlex}>
        <CardGroup className={styles.cardGroup}>
          {arts.map((item) => (
            <div key={item.id} className={item.Category ? styles.cardSizeCat : styles.cardSizeType}>
              <Link to={item.Category ? `/galery/${item.Type.id}/${item.Category.id}` : `/art/${item.id}`} onClick={handleScrollToTop}>
                <img
                  className={item.Category ? styles.imageCat : styles.imageType}
                  src={item.imageUrl}
                  alt={item.Category?.label || "Oeuvre"}
                />
                {item.Category && (
                  <h3 className={styles.catTitle}>
                    {item.Category.label}
                  </h3>
                )}
              </Link>
            </div>
          ))}
        </CardGroup>
      </div>
    </div>
  )
}
export default ByType
